import { JobExpandablePropertyType, JobTasksExpandablePropertyType } from '@/enum'
import { ItemTypeExpression } from '@/enum/LinqExpressionType'

const updateResponseExpandableResources = [
  JobExpandablePropertyType.ASSIGNED_EMPLOYEES,
  JobExpandablePropertyType.ASSIGNED_EMPLOYEES_EMPLOYEE,
  JobExpandablePropertyType.TASK_TEMPLATES,
  // JobExpandablePropertyType.TASK_TEMPLATES_SECTIONS,
  JobExpandablePropertyType.WORK_ORDER_VENDOR,
  JobExpandablePropertyType.ASSET,
  JobExpandablePropertyType.ASSET_INFO,
  JobExpandablePropertyType.ASSET_EQUIPMENT,
  JobExpandablePropertyType.ASSET_MACHINE,
  JobExpandablePropertyType.ASSET_VEHICLE,
  JobExpandablePropertyType.ISSUE_REPORTER,
  JobExpandablePropertyType.DOCUMENTS,
  JobExpandablePropertyType.MAINTENANCE_TYPES
]

export const expandedProperties = {
  [ItemTypeExpression.Expand]: updateResponseExpandableResources.join(',')
}

const updateJobTaskResponseExpandableResources = [
  JobTasksExpandablePropertyType.JOB,
  JobTasksExpandablePropertyType.ASSET_INFO,
  JobTasksExpandablePropertyType.DATA,
  JobTasksExpandablePropertyType.DOCUMENTS,
  JobTasksExpandablePropertyType.DATA_SECTIONS,
  JobTasksExpandablePropertyType.EMPLOYEES
]

export const expandedJobTaskProperties = {
  [ItemTypeExpression.Expand]: updateJobTaskResponseExpandableResources.join(',')
}
